import React, { useState, useEffect, memo, useMemo } from 'react';
import { connect } from 'react-redux';
import Paginated from './Paginated';
import { Link } from 'react-router-dom';
import { importIcon } from '../../../Image/Index';
import { getTransaction, clearTransaction } from '../../../actions/transaction';
import { ValidatorForm } from 'react-form-validator-core';
import SelectValidator from "../../partial/SelectValidator"
import { getAllTrasaction } from '../../../services/auth';
import { decrypt } from '../../../utils/encodingdecoding';
import Header from "../../layout/Header";
import { COLUMNS } from './column';
import { getDisplayDate } from '../../../utils/helper';
import TransactionViewModal from '../transactionsList/TransactionViewModal';

const RedemptionList = memo(
    ({ getTransaction, Transaction, clearTransaction }) => {
        const [data, setData] = useState([]);
        const [transactionCount, setTransactionCount] = useState();
        const [loader, setLoader] = useState(true);
        const [showLogin, setShowLogin] = useState(false);
        const [transactionId, setTransactionId] = useState('');

        let id = decrypt(localStorage.getItem('Id'));

        useEffect(() => {
            let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
            if (tempPageIndex === 1) {
                fetch();
            }
            // eslint-disable-next-line
        }, []);

        useEffect(() => {
            const ShortData = async () => {
                let tempData = Transaction?.data?.transactions;
                if (tempData) {
                    await tempData && (
                        tempData = tempData?.map((val) => ({
                            transactionId: val.transactionId,
                            ordercode: val.transactionDetail?.ordercode,
                            value: val.transactionDetail?.values,
                            redemption_type: val.transactionDetail?.redemption_type,
                            productname: val.transactionDetail?.itemlist
                                ?.map((item) => item.productname)
                                .join(", "),
                            product_code: val.transactionDetail?.itemlist
                                ?.map((item) => item.product_code)
                                .join(", "),
                            title: val.transactionDetail?.itemlist
                                ?.map((item) => item.title)
                                .join(", "),
                            image: val.transactionDetail?.itemlist?.map(
                                (item) => item.image
                            ),
                            transactionProcessedDate: getDisplayDate(
                                val?.transactionProcessedDate
                            ),
                            action: (
                                <Link
                                    to=''
                                    state={{
                                        transactionId: Array.isArray(
                                            val.customer,
                                        )
                                            ? val?.customer?.[0]?.customercode
                                            : val?.customer?.customercode,
                                    }}
                                    onClick={() =>
                                        handleViewModal(val.transactionId)
                                    }>
                                    <i className='fa-solid fa-eye'></i> View
                                    Details
                                </Link>
                            )
                        }))
                    )

                    if (tempData) {
                        await tempData.sort(function (a, b) {
                            if (a.transactionProcessedDate === null) {
                                return 1;
                            } else if (b.transactionProcessedDate === null) {
                                return -1;
                            }
                            const dateA = new Date(a.transactionProcessedDate);
                            const dateB = new Date(b.transactionProcessedDate);
                            if (dateA < dateB) {
                                return 1;
                            } else if (dateA > dateB) {
                                return -1;
                            } else {
                                const timeA = dateA.getTime();
                                const timeB = dateB.getTime();
                                return timeB - timeA;
                            }
                        });
                    }
                    setData(tempData);
                }
            };

            ShortData();

        }, [Transaction]);

        const handleViewModal = (data) => {
            setShowLogin(true);
            setTransactionId(data);
        };

        const fetch = async () => {
            try {
                setLoader(true);
                // await clearTransaction();
                const token = JSON.parse(localStorage.getItem('token_gen'));
                let id = localStorage.getItem('Id');
                await getTransaction(token?.access_token, id, 1, 50);
                setLoader(false);
            } catch (err) {
                setLoader(false);
            }
        };

        const generateCSV = async () => {
            setLoader(true);

            try {
                const token = JSON.parse(localStorage.getItem('token_gen'));
                const id = localStorage.getItem('Id');

                if (!token?.access_token || !id) {
                    throw new Error('Missing token or ID');
                }
                const response = await getAllTrasaction(
                    token.access_token,
                    id,
                    1,
                    transactionCount,
                );
                const transactions = response?.transactions || [];
                const transformedData = transactions?.map((val) => {
                    let earning = val?.earning || 0;
                    let total = 0;
                    let type = '';

                    const positiveValues =
                        val?.qualifiedCampaign?.filter(
                            (item) => item.value > 0,
                        ) || [];
                    const totalPositiveValue = positiveValues?.reduce(
                        (acc, curr) => acc + curr.value,
                        0,
                    );

                    return {
                        transactionId: val?.transactionId || 'N/A',
                        isQualified:
                            val?.transactionDetail?.transactionType ===
                                'purchase' && val?.qualifiedCampaign?.length
                                ? 'Yes'
                                : 'No',
                        totalAmount: val?.transactionDetail?.totalAmount
                            ? val?.transactionDetail?.totalAmount
                            : '-',
                        transactionType: val?.transactionDetail?.bitType?.length
                            ? val?.transactionDetail?.bitType
                            : val?.transactionDetail?.transactionType || 'N/A',
                        earning,
                        transactionProcessedDate:
                            getDisplayDate(
                                val?.transactionProcessedDate
                            ) || 'N/A',
                    };
                });
                const csvHeaders = [
                    'Transaction ID',
                    'IsQualified',
                    'Transaction Type',
                    'Earning',
                    'Date'
                ];
                const csvData = [
                    csvHeaders,
                    ...transformedData?.map((row) => [
                        row.transactionId,
                        row.isQualified,
                        row.transactionType,
                        row.earning,
                        row.transactionProcessedDate
                    ]),
                ];
                const csvContent =
                    'data:text/csv;charset=utf-8,' +
                    csvData.map((row) => row.join(',')).join('\n');
                const encodedUri = encodeURI(csvContent);
                const link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', 'report.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error('Error generating CSV:', error.message || error);
            } finally {
                setLoader(false);
            }
        };

        useEffect(() => {
            setTransactionCount(Transaction?.data?.totalCount);
        }, [Transaction]);

        return (
            <>
                <Header
                    name={'Redemption'}
                />
                {loader && (
                    <div className='mainPreloaderMain'>
                        <div className='mainPreloader'>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                )}
                <div className='dashboard__content'>
                    <div className='container-fluid'>
                        <div className='dashboard__transactionsCard'>
                            <div className='dashboard__header'>
                                <div className='dashboard__left'>
                                    <h4 id='transction_list'>
                                        All Redemptions
                                    </h4>
                                </div>
                                <div className='dashboard__right'>
                                    <button
                                        onClick={generateCSV}
                                        className='btn btn-default'>
                                        <i
                                            class='fa-solid fa-download'
                                            style={{ marginRight: '10px' }}></i>
                                        Download Redemption
                                    </button>
                                </div>
                            </div>
                            <div className='dashboard__body'>
                                <Paginated
                                    data={data}
                                    columns={COLUMNS}
                                    setLoader={setLoader}
                                    loader={loader}
                                />
                            </div>
                        </div>
                        {showLogin && (
                            <TransactionViewModal
                                show={showLogin}
                                close={() => setShowLogin(false)}
                                transactionId={transactionId}
                            />
                        )}
                    </div>
                </div>
            </>
        );
    },
);

const mapStateToProps = (state) => ({
    Transaction: state.Transaction,
});
const mapDispatchToProps = {
    getTransaction,
    clearTransaction,
};

export default connect(mapStateToProps, mapDispatchToProps)(RedemptionList);
